import { render } from "./form-maintenance-bubble.vue?vue&type=template&id=2910d7a8&scoped=true"
import script from "./form-maintenance-bubble.vue?vue&type=script&lang=js"
export * from "./form-maintenance-bubble.vue?vue&type=script&lang=js"

import "./form-maintenance-bubble.vue?vue&type=style&index=0&id=2910d7a8&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2910d7a8"],['__file',"src/components/notepad/form-maintenance/form-maintenance-bubble.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2910d7a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2910d7a8', __exports__)) {
    api.reload('2910d7a8', __exports__)
  }
  
  module.hot.accept("./form-maintenance-bubble.vue?vue&type=template&id=2910d7a8&scoped=true", () => {
    api.rerender('2910d7a8', render)
  })

}


export default __exports__